import type { CountdownSegment } from '../config/wwdc';

type CountdownProps = {
  segments: CountdownSegment[];
  ariaLabel: string;
};

const Countdown = ({ segments, ariaLabel }: CountdownProps) => (
  <div className="countdown-display" aria-label={ariaLabel}>
    {segments.map((segment) => (
      <span className="countdown-segment" key={segment.label}>
        <span className="countdown-display__text countdown-segment__value">{segment.value}</span>
        <span className="countdown-segment__label">{segment.label}</span>
      </span>
    ))}
  </div>
);

export default Countdown;
